<template>
  <div class="document">
    <div class="document__header">Documents</div>

    <div class="document__body--loader" v-if="pageLoading">
      <PageLoader />
    </div>

    <div class="document__body" v-if="!pageLoading">
      <!-- <div class="document__body--alert">
        <div
          class="document__body--alert-text"
        >Download all the documents your company wants you to sign here:</div>
        <div class="document__body--alert-btn">Download Documents</div>
      </div>-->

      <div class="document__body--list">
        <p>Your Uploads</p>
        <div>
          <div class="document__body--list-head">
            <div>Name</div>
            <div>Date Uploaded</div>
            <div>Action</div>
          </div>
          <div class="document__body--list-body">
            <div v-for="(doc, index) in document" :key="doc.index">
              <div>
                <font-awesome-icon icon="file" />
                &nbsp;{{doc.title}}
              </div>
              <div>{{doc.created_at.split(" ")[0]}}</div>
              <div>
                <span>
                  <a :href="`${s3URL}/${doc.url}`" target="_blank" download>
                    <font-awesome-icon icon="download" />
                  </a>
                </span>
                &nbsp;&nbsp;
                <span
                  class="nospin"
                  @click="deleteDocument(index, doc.id)"
                >
                  <font-awesome-icon icon="times" />
                </span>
                <!-- <span class="spin">
                  <font-awesome-icon icon="spinner" />
                </span>-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="document__body--upload">
        <p>Upload New Document</p>
        <div class="document__body--upload-form">
          <label for="name">Name of Document</label>
          <div class="document__body--upload-form-input">
            <input type="text" v-model="docName" />
          </div>
          <label for="doc">Upload Document:</label>
          <div class="document__body--upload-form-img">
            <span v-if="!uploadedFile">
              <font-awesome-icon icon="upload" />
            </span>
            <p v-if="uploadedFile">{{uploadedFileName}}</p>
            <p v-if="!uploadedFile">upload jpg, pdf, doc</p>
            <input type="file" ref="doc" @change="uploadFile" />
          </div>
        </div>

        <div class="document__body--upload-err">
          <span v-if="noFile">You have not uploaded any file.</span>
          <span v-if="fileSize">File must be less than 10 megabyte.</span>
          <span v-if="networkErr">Network error. Please try again later.</span>
          <span v-if="nameError">Please enter title of document.</span>
        </div>

        <div class="document__body--upload-btn" v-if="!btnLoader" @click="sendFile">Upload Document</div>
        <div class="document__body--upload-btn" v-if="btnLoader">
          <WhiteLoader />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";
import * as types from "../../../store/constant";

export default {
  name: "DocumentsUpload",
  components: {
    WhiteLoader,
    PageLoader
  },
  data() {
    return {
      item: "document",
      s3URL: types.S3_BUCKET_URL,
      docName: "",
      nameError: false,
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      fileExt: "",
      noFile: false,
      fileSize: false,
      btnLoader: false,
      pageLoading: true,
      respMsg: "",
      networkErr: false,
      document: []
    };
  },
  methods: {
    uploadFile() {
      this.uploadedFile = false;
      this.noFile = false;
      this.fileSize = false;
      this.networkErr = false;
      this.nameError = false;
      this.fileName = this.$refs.doc;
      this.file = this.$refs.doc.files[0];
      this.fileExt = this.fileName.value.split(".").pop();

      if (this.file) {
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        this.uploadedFile = true;
      }
    },
    sendFile() {
      this.noFile = false;
      this.fileSize = false;
      this.networkErr = false;
      this.nameError = false;

      if (this.docName.trim() === "") {
        this.nameError = true;
        return;
      }

      if (!this.fileExt) {
        this.noFile = true;
        return;
      }
      if (!this.file) {
        this.noFile = true;
        return;
      }

      if (this.file.size > 10000000) {
        this.fileSize = true;
        return;
      }

      let formData = new FormData();
      formData.append("title", this.docName.trim());
      formData.append("document_type", "null");
      formData.append("file", this.file);

      this.btnLoader = true;

      this.$http
        .post(types.POST_EMPLOYEE_FILE_API, formData)
        .then(resp => {
          this.btnLoader = false;
          this.document = [...resp.data.data[0].employee_document];
          this.docName = "";
          this.uploadedFile = false;
          this.uploadedFileName = "";
          this.$refs.doc.value = "";
          this.file = "";
          this.pageLoading = true;
          this.fetchDocuments();
        })
        .catch(err => {
          this.networkErr = true;
          this.btnLoader = false;
        });
    },
    fetchDocuments() {
      this.$http.get(types.POST_EMPLOYEE_FILE_API).then(resp => {
        this.document = [...resp.data.data[0].employee_document];
        this.pageLoading = false;
      });
    },
    deleteDocument(index, val) {
      this.networkErr = false;
      let doc = [];
      doc = [...this.document];
      this.document.splice(index, 1);
      this.$http
        .delete(types.POST_EMPLOYEE_FILE_API, {
          data: {
            document_id: val
          }
        })
        .then(resp => {
          if (resp.data.data.employee_documents.length === 0) {
            this.doc = [];
          }
        })
        .catch(err => {
          this.document = [...doc];
        });
    }
  },
  created() {
    this.fetchDocuments();
  }
};
</script>

<style lang="scss" scoped>
.document {
  padding: 20px 50px;

  @media (max-width: 500px) {
    padding: 20px 10px;
  }

  > .document__header {
    border-bottom: 2px solid rgb(234, 234, 234);
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.16;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    padding-bottom: 5px;
  }

  > .document__body {
    padding: 50px 0 100px 0;

    > .document__body--alert {
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 #fff9f0;
      border: solid 2px #ffe7bd;
      background-color: #fff9f0;
      padding: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      width: 600px;

      > .document__body--alert-text {
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: left;
        color: #000;
      }

      > .document__body--alert-btn {
        width: 200px;
        border-radius: 5px;
        padding: 12px 0;
        background-color: #5099de;
        font-size: 10px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
      }
    }

    > .document__body--list {
      > p {
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > div {
        > .document__body--list-head {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          height: 50px;
          padding: 0 50px;

          > div {
            font-size: 12px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }

          > div:nth-child(1) {
            width: 50%;
          }

          > div:nth-child(2) {
            width: 25%;
          }

          > div:nth-child(3) {
            width: 25%;
          }
        }

        > .document__body--list-body {
          border-top: 5px solid #5099de;

          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            height: 50px;
            padding: 0 50px;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
            margin-bottom: 20px;

            > div {
              font-size: 12px;
              font-weight: 200;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: left;

              > .spin {
                display: none;
              }

              > span:nth-child(2) {
                color: #f3826c;
                cursor: pointer;
              }

              > span:nth-child(3) {
                color: #f3826c;
              }
            }

            > div:nth-child(1) {
              width: 50%;
              color: #5099de;
            }

            > div:nth-child(2) {
              width: 25%;
              color: #000000;
            }

            > div:nth-child(3) {
              width: 25%;
              color: #000000;
            }
          }
        }
      }
    }

    > .document__body--upload {
      margin-top: 50px;
      > p {
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > .document__body--upload-form {
        margin-bottom: 10px;
        > label {
          font-size: 12px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.33;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        > .document__body--upload-form-input {
          width: 400px;
          height: 40px;
          border: solid 1px #caced5;
          background-color: #ffffff;
          overflow: hidden;
          margin-bottom: 20px;

          > input {
            border: 0;
            outline: 0;
            width: 100%;
            height: 40px;
            padding: 0 5px;
            font-size: 12px;
            font-weight: 300;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.33;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }
        }

        > .document__body--upload-form-img {
          width: 400px;
          border: dotted 1px #5099de;
          background-color: #ffffff;
          text-align: center;
          padding: 10px 0;
          position: relative;

          > span {
            font-size: 10px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;

            > a {
              text-decoration: none;
              color: #5099de;
            }
          }

          > p {
            font-size: 10px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
            margin: 0;
          }

          > input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
      }

      .document__body--upload-err {
        font-size: 12px;
        color: red;
        font-style: italic;
        text-align: left;
        height: 30px;
        margin-bottom: 10px;
      }

      > .document__body--upload-btn {
        border-radius: 5px;
        background-color: #5099de;
        width: 150px;
        height: 40px;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }
  }
}

.document__body--loader {
  width: 55px;
  height: 55px;
  margin: 50px auto;
}
</style>